import React, { useEffect, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import ReactPaginate from "react-paginate"

import { Link } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"

import { useHistory } from "react-router-dom"

import API from "../../api/api"

import createOtherUser from "../../createUserFirebase"

import SweetAlert from "react-bootstrap-sweetalert"

import { db, storage } from "../../helpers/firebase_helper"
import moment from "moment"

const TableList = ({
  createButton,
  title,
  titleList,
  tableData,
  edit,
  navLocation,
  getAdminList,
  nextPage,
  totalPagesCount,
  pageNumberThreshold,
}) => {
  let rowNumber = 1
  let history = useHistory()
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal_large, setmodal_large] = useState(false)
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_small, setmodal_small] = useState(false)
  const [modal_center, setmodal_center] = useState(false)
  const [modal_scroll, setmodal_scroll] = useState(false)
  const [modal_fullscreen, setmodal_fullscreen] = useState(false)
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [servicesList, setServicesList] = useState([])
  const [serviceData, setServiceData] = useState({
    partner_type: "",
    job: 0,
    base_fare: 0,
    additional_fare: 0,
    helper_fare: 0,
    helper_additional_fare: 0,
    known_issues: 0,
  })
  const [enableEdit, setEnableEdit] = useState(false)
  const [openCreateAdminModal, setOpenCreateAdminModal] = useState(false)
  const [createAdminData, steCreateAdminData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  })
  const [errorMessageModal, setErrorMessageModal] = useState(false)
  const [createAdminProfileImage, setCreateAdminProfileImage] = useState(null)

  const [showSuccessModal, setShowSuccessModal] = useState(false)

  const [createSpinner, setCreateSpinner] = useState(false)

  function tog_standard() {
    setmodal_standard(!modal_standard)
    removeBodyCss()
  }

  function tog_fullscreen() {
    setmodal_fullscreen(!modal_fullscreen)
    removeBodyCss()
  }

  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_large() {
    setmodal_large(!modal_large)
    removeBodyCss()
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_small() {
    setmodal_small(!modal_small)
    removeBodyCss()
  }

  function tog_center() {
    setmodal_center(!modal_center)
    removeBodyCss()
  }

  function tog_scroll() {
    setmodal_scroll(!modal_scroll)
    removeBodyCss()
  }

  const [fnm, setfnm] = useState(false)
  const [lnm, setlnm] = useState(false)
  const [unm, setunm] = useState(false)
  const [city, setcity] = useState(false)
  const [stateV, setstateV] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()

    var fnm = document.getElementById("validationTooltip01").value
    var lnm = document.getElementById("validationTooltip02").value
    var unm = document.getElementById("validationTooltipUsername").value
    var city = document.getElementById("validationTooltip03").value
    var stateV = document.getElementById("validationTooltip04").value

    if (fnm === "") {
      setfnm(false)
    } else {
      setfnm(true)
    }

    if (lnm === "") {
      setlnm(false)
    } else {
      setlnm(true)
    }

    if (unm === "") {
      setunm(false)
    } else {
      setunm(true)
    }

    if (city === "") {
      setcity(false)
    } else {
      setcity(true)
    }

    if (stateV === "") {
      setstateV(false)
    } else {
      setstateV(true)
    }

    var d1 = document.getElementsByName("validate")

    document.getElementById("tooltipForm").classList.add("was-validated")

    for (var i = 0; i < d1.length; i++) {
      d1[i].style.display = "block"
    }
  }

  //for change tooltip display propery
  function changeHandeler(event, eleId) {
    if (event.target.value !== "")
      document.getElementById(eleId).style.display = "none"
    else document.getElementById(eleId).style.display = "block"
  }

  const postService = () => {
    if (enableEdit) {
      try {
        API.updateService(serviceData)
          .then(response => {
            console.log("saved service response", response)
          })
          .catch(e => {})
      } catch (e) {}
    } else {
      try {
        API.saveServices(serviceData)
          .then(response => {
            console.log("saved service response", response)
          })
          .catch(e => {})
      } catch (e) {}
    }
    setEnableEdit(false)
  }

  // const getServices = async () => {
  //   try {
  //     API.getServicesList()
  //       .then(response => {
  //         setServicesList(response.data.data)
  //         console.log("services response", response.data.data)
  //       })
  //       .catch(e => {})
  //   } catch (e) {}
  // }

  // useEffect(() => {
  //   console.log("Services api called")
  //   getServices()
  // }, [])

  /**
   * This function creates new admin
   */
  const createAdminUser = async () => {
    setCreateSpinner(true)
    const adminUserUid = await createOtherUser(
      createAdminData.email,
      createAdminData.password
    )

    if (!adminUserUid) {
      setErrorMessageModal(true)
      setCreateSpinner(false)
      return
    } else {
      setErrorMessageModal(false)
    }

    const path = await storage.ref(
      "admin/" + moment().unix() + createAdminProfileImage.name
    )

    path.put(createAdminProfileImage).then(function () {
      path.getDownloadURL().then(async function (url) {
        await db
          .collection("users")
          .doc(adminUserUid)
          .set(
            {
              ...createAdminData,
              admin: true,
              createdAt: Number(moment().format("x")),
              updatedAt: Number(moment().format("x")),
              profileImage: url,
            },
            {
              merge: true,
            }
          )
        setCreateSpinner(false)
        setOpenCreateAdminModal(false)
        setShowSuccessModal(true)
      })
    })
  }

  // Invoke when user click to request another page.
  const handlePageClick = event => {
    nextPage(event.selected + 1)
  }

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row className="mt-2">
              <Col md="10">
                <h4>{title}</h4>
              </Col>
              <Col md="2">
                {createButton && (
                  <Button
                    onClick={() => {
                      tog_fullscreen()
                    }}
                  >
                    Create new Service
                  </Button>
                )}
              </Col>
            </Row>

            {/* <Link to="/details"> */}
            <div className="table-responsive">
              {title === "Admins" ? (
                <button
                  onClick={() => {
                    steCreateAdminData({
                      name: "",
                      email: "",
                      password: "",
                      phone: "",
                    })
                    setCreateAdminProfileImage(null)
                    setOpenCreateAdminModal(true)
                  }}
                >
                  + Create Admin{" "}
                </button>
              ) : (
                ""
              )}

              <Table className="table mb-0">
                {console.log(titleList)}
                <thead>
                  <tr>
                    {titleList &&
                      titleList?.map((item, index) => {
                        return <th key={`title-${index}`}>{item}</th>
                      })}
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 &&
                    tableData?.map(item => {
                      return (
                        <>
                          <tr
                            id={item.id}
                            key={`order-${item.id}`}
                            onClick={() => {
                              if (navLocation)
                                history.push(`${navLocation}${item.id}`)
                            }}
                          >
                            <th scope="row"> {pageNumberThreshold + rowNumber++}</th>
                            <td>{item.name}</td>
                            <td>{item.phone}</td>
                            <td>
                              {item?.serviceProvider
                                ? "Service Provider"
                                : item?.admin
                                ? "Admin"
                                : "User"}
                            </td>
                            <td>{item?.disabled ? "Disabled" : "Enabled"}</td>
                            <td>{item?.email}</td>
                            {edit && (
                              <td>
                                <Button
                                  onClick={() => {
                                    tog_fullscreen()
                                    setEnableEdit(true)
                                  }}
                                >
                                  Edit
                                </Button>
                              </td>
                            )}
                          </tr>
                        </>
                      )
                    })}
                </tbody>
              </Table>
              <div className="d-flex p-d-2">
                  <ReactPaginate
                    previousLabel="Previous"
                    nextLabel="Next"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={totalPagesCount?totalPagesCount:0}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={10}
                    onPageChange={handlePageClick}
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              <Col sm={6} md={4} xl={3}>
                <Modal
                  size="sm"
                  isOpen={modal_fullscreen}
                  toggle={() => {
                    tog_fullscreen()
                  }}
                  className="modal-fullscreen"
                >
                  <Row>
                    <Col xl="20">
                      <Card>
                        <CardBody>
                          <h3 className="card-title mb-4">
                            Service Add / Edit
                          </h3>

                          <AvForm className="needs-validation">
                            <Row>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom01">
                                    Partner Type
                                  </Label>
                                  <AvField
                                    name="partnerType"
                                    placeholder="Partner Type"
                                    type="text"
                                    errorMessage=" Please provide a valid partner type."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom01"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        partner_type: e.target.value,
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom02">
                                    Base Fare
                                  </Label>
                                  <AvField
                                    name="baseFare"
                                    placeholder="Base Fare"
                                    type="text"
                                    errorMessage="Please provide a valid base fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom02"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        base_fare: parseInt(e.target.value),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom03">
                                    Additional Fare
                                  </Label>
                                  <AvField
                                    name="additionalFare"
                                    placeholder="Additional Fare"
                                    type="text"
                                    errorMessage=" Please provide a valid additional fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom03"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        additional_fare: parseInt(
                                          e.target.value
                                        ),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04">
                                    Job Type
                                  </Label>
                                  <AvField
                                    name="jobType"
                                    placeholder="Job Type"
                                    type="text"
                                    errorMessage=" Please provide a valid job type."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom04"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        job: parseInt(e.target.value),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom05">
                                    Helper Fare
                                  </Label>
                                  <AvField
                                    name="helperFare"
                                    placeholder="Helper Fare"
                                    type="text"
                                    errorMessage="Please provide a valid helper fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom05"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        helper_fare: parseInt(e.target.value),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom06">
                                    Helper Additional Fare
                                  </Label>
                                  <AvField
                                    name="zip"
                                    placeholder="Helper Additional Fare"
                                    type="text"
                                    errorMessage=" Please provide a valid helper additional fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom06"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        helper_additional_fare: parseInt(
                                          e.target.value
                                        ),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom07">
                                    Known Issues (6 Items)
                                  </Label>
                                  <AvField
                                    name="knownIssues"
                                    placeholder="Known issues"
                                    type="text"
                                    errorMessage=" Please provide a valid known issues."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom07"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        known_issues: e.target.value,
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            {/* <Row>
                              <Col lg="12">
                                <FormGroup className="mb-3">
                                  <div className="form-check">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="invalidCheck"
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="invalidCheck"
                                    >
                                      {" "}
                                      Agree to terms and conditions
                                    </Label>
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row> */}
                            {/* <Button color="primary" type="submit">
                              Submit
                            </Button> */}
                            <Row>
                              <Col md="10" />
                              <Col md="2">
                                <div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      tog_fullscreen()
                                      setEnableEdit(false)
                                    }}
                                    className="btn btn-secondary waves-effect"
                                    data-dismiss="modal"
                                    style={{}}
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary waves-effect waves-light"
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => {
                                      postService()
                                    }}
                                  >
                                    Save changes
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </AvForm>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Modal>
              </Col>
            </div>
            {/* </Link> */}
          </CardBody>
        </Card>
      </Col>

      <Modal
        isOpen={openCreateAdminModal}
        backdrop={true}
        toggle={() => {
          setOpenCreateAdminModal(false)
        }}
      >
        <ModalHeader>Create Admin</ModalHeader>
        <ModalBody>
          <div className="pb-3">
            Name:{" "}
            <Input
              value={createAdminData.name}
              onChange={e => {
                steCreateAdminData({
                  ...createAdminData,
                  name: e.target.value,
                })
              }}
            />
          </div>
          <div className="pb-3">
            Phone:{" "}
            <Input
              value={createAdminData.phone}
              onChange={e => {
                steCreateAdminData({
                  ...createAdminData,
                  phone: e.target.value,
                })
              }}
            />
          </div>
          <div className="pb-3">
            Profile image:{" "}
            <input
              type="file"
              class="form-control"
              id="customFile"
              data-kt-image-input="true"
              accept="image/png, image/jpeg, image/svg"
              onChange={e => setCreateAdminProfileImage(e.target.files[0])}
            />
          </div>
          <div className="pb-3">
            Emal:{" "}
            <Input
              value={createAdminData.email}
              onChange={e => {
                steCreateAdminData({
                  ...createAdminData,
                  email: e.target.value,
                })
              }}
              type="email"
            />
          </div>
          <div className="pb-3">
            Password:{" "}
            <Input
              value={createAdminData.password}
              onChange={e => {
                steCreateAdminData({
                  ...createAdminData,
                  password: e.target.value,
                })
              }}
              type="password"
            />
          </div>
        </ModalBody>
        <div className="m-auto mb-3">
          <Button
            variant="dark"
            className="bg-dark text-white m-auto"
            onClick={() => {
              setOpenCreateAdminModal(false)
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="bg-success text-white m-auto"
            onClick={() => {
              createAdminUser()
            }}
          >
            {" "}
            {createSpinner && (
              <div
                class="spinner-border text-light"
                role="status"
                style={{ width: "18px", height: "18px" }}
              >
                {/* <span class="sr-only">Loading...</span> */}
              </div>
            )}
            {!createSpinner ? "Create" : ""}
          </Button>
        </div>
      </Modal>
      <SweetAlert
        success
        show={showSuccessModal}
        confirmBtnText="Ok"
        confirmBtnBsStyle={"success"}
        title={"Success"}
        onConfirm={() => {
          getAdminList()
          setShowSuccessModal(false)
          setOpenCreateAdminModal(false)
        }}
      ></SweetAlert>
      <SweetAlert
        error
        show={errorMessageModal}
        confirmBtnText="Ok"
        confirmBtnBsStyle={"error"}
        title={"Error"}
        onConfirm={() => {
          setErrorMessageModal(false)
          setCreateSpinner(false)
        }}
      >
        Something went wrong or email already exists
      </SweetAlert>
    </Row>
  )
}

export default TableList

//TODO: REPLACE THE  TABLE DATA STATIC VALUE WITH API
